import { Component } from '@angular/core';
import { FormControlDirective, FormControlName } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { AuthService } from 'ng-shared-library';
import { Title } from '@angular/platform-browser';
// import { Gtag } from 'angular-gtag';
declare var gtag: any;

// attach a custom nativeElement property to all FormControl objects
const originFormControlNgOnChanges = FormControlDirective.prototype.ngOnChanges;
FormControlDirective.prototype.ngOnChanges = function () {
  this.form.nativeElement = this.valueAccessor._elementRef
    ? this.valueAccessor._elementRef.nativeElement
    : null;
  return originFormControlNgOnChanges.apply(this, arguments);
};

const originFormControlNameNgOnChanges = FormControlName.prototype.ngOnChanges;
FormControlName.prototype.ngOnChanges = function () {
  const result = originFormControlNameNgOnChanges.apply(this, arguments);
  this.control.nativeElement = this.valueAccessor._elementRef
    ? this.valueAccessor._elementRef.nativeElement
    : null;
  return result;
};

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent {
  constructor(
    private authService: AuthService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title
  ) {
    this.authService.isLoggedIn().subscribe(resp => {
      if (!resp && !router.url.startsWith('/authenticate')) {
        this.authService.startAuthentication();
      }
    });
    // task 8057 - set page title
    // task 11043 - gtag page view logic
    this._setPageTitle();
  }

  private _setPageTitle() {
    const appTitle = this.titleService.getTitle();
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => {
          let child = this.activatedRoute.firstChild;
          while (child.firstChild) {
            child = child.firstChild;
          }
          let title = child.snapshot.data['title'];
          if (title) {
            // task 11043 - pass the page title to google w/o prepended client code
            gtag('send', 'pageview', title);

            // add client code prefix on page title if it exists (app-route "data" properties)
            const clientCode = child.snapshot.paramMap.get('client_code');
            return clientCode ? `${clientCode} - ${title}` : title;
          }

          return appTitle;
        })
      )
      .subscribe((title: string) => {
        this.titleService.setTitle(title);
      });
  }
}
